'use client';

import {
  PRACTICE_INVITE_ACTION,
  TRIALS_AND_UPGRADES_SCREEN,
} from '@heidi/commerce/contracts';
import {
  DialogDrawer,
  DialogDrawerContent,
} from '@heidi/design-system/mobile-responsive-dialog-drawer';
import { useAtom } from 'jotai';
import { lazy, Suspense, useCallback, useState } from 'react';

import { getCommerceBillingUiPorts } from '../../settings/billing/billing-ui-ports';
import { getCommerceTrialsUiPorts } from '../trials-ui-ports';
import { practiceInviteTeamModalOpenAtom } from './practice-invite-team-modal-atoms';
import { PracticeInviteTeamModalLoading } from './practice-invite-team-modal-loading';

const PracticeInviteTeamModalContent = lazy(() =>
  import('./practice-invite-team-modal-content').then((mod) => ({
    default: mod.PracticeInviteTeamModalContent,
  }))
);

export function PracticeInviteTeamModal() {
  const [isOpen, setIsOpen] = useAtom(practiceInviteTeamModalOpenAtom);
  const [isDialogVisible, setIsDialogVisible] = useState(isOpen);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        getCommerceTrialsUiPorts().analytics.trackPracticeInviteClick({
          screen_name: TRIALS_AND_UPGRADES_SCREEN.practiceInviteTeam,
          action: PRACTICE_INVITE_ACTION.close,
          label: 'Close',
        });
        handleClose();
      }
    },
    [handleClose]
  );

  if (getCommerceBillingUiPorts().isAppleCompliantBuild()) {
    return null;
  }

  return (
    <DialogDrawer
      open={isOpen}
      onOpenChange={handleOpenChange}
      onOpenChangeComplete={setIsDialogVisible}
    >
      <DialogDrawerContent
        className="mb-auto flex h-fit max-w-[470px] flex-col items-center gap-6 border-0 p-4 sm:p-8"
        overlayClassName="backdrop-blur-[3px]"
        dismissible
        hideCloseIcon
      >
        {isOpen && isDialogVisible ? (
          <Suspense fallback={<PracticeInviteTeamModalLoading />}>
            <PracticeInviteTeamModalContent onClose={handleClose} />
          </Suspense>
        ) : (
          <PracticeInviteTeamModalLoading />
        )}
      </DialogDrawerContent>
    </DialogDrawer>
  );
}
